import { useQueryClient } from '@tanstack/react-query';

import type {
  ApiPayNowResult,
  OrgBillingArgs,
} from '../../api/types/payments.types';

import { payNow } from '../../api/platformBilling.api';
import { queryKeys } from '../../queryKeys';
import { useMutation } from '../base';

/**
 * „Plati sad" — izlaz iz suspenzije/duga. Naplata je ASINHRONA (BillingRunner
 * ≤1 min): posle uspeha UI poll-uje billing pregled dok status ne postane
 * ACTIVE ili se plan završi (ENDED, bez pretplate) konačnim izmirenjem duga.
 * Istek polling-a ne potvrđuje ishod naplate. 409 = obrada u toku → nastaviti poll.
 */
export function usePayNow() {
  const queryClient = useQueryClient();
  const response = useMutation<ApiPayNowResult | null, null, OrgBillingArgs>({
    mutationFn: payNow,
    onSuccess: () => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.platformBilling.fetchOrgBillingOverview._def,
      });
    },
  });
  return {
    ...response,
    isLoading: response.status === 'pending',
  };
}
